import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'

export const LoadingScreen = () => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => prev < 100 ? prev + 1 : prev)
    }, 30)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className={styles.loadingScreen}>
      <div className={styles.loadingContent}>
        <h2 className={styles.loadingTitle}>Loading Knowledge Base</h2>
        <div className={styles.progressBar}>
          <div 
            className={styles.progressFill} 
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className={styles.loadingText}>
          Initializing Holographic Interface...{progress}%
        </div>
      </div>
    </div>
  )
} 